
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    export class IcReport04Dialog extends Serenity.EntityDialog<IcReport04Row, any> {
        protected getFormKey() { return IcReport04Form.formKey; }
        protected getIdProperty() { return IcReport04Row.idProperty; }
        protected getLocalTextPrefix() { return IcReport04Row.localTextPrefix; }
        protected getNameProperty() { return IcReport04Row.nameProperty; }
        protected getService() { return IcReport04Service.baseUrl; }
        protected getDeletePermission() { return IcReport04Row.deletePermission; }
        protected getInsertPermission() { return IcReport04Row.insertPermission; }
        protected getUpdatePermission() { return IcReport04Row.updatePermission; }

        protected form = new IcReport04Form(this.idPrefix);
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }
    }
}